import React from 'react';

interface ICtaSlotProps {
    children?: React.ReactNode;
}

const CtaSlot: React.FC<ICtaSlotProps> = ({ children }) => (
    <div className="content-page__cta">{children}</div>
);

export default CtaSlot;
